<template>
  <div class="new" @click="toNew">
    <div>
      <img :src="info.img" alt="新闻图片">
    </div>
    <div>
      <div class="new-title">{{ info.title }}</div>
      <p class="new-content" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  data () {
    return {

    }
  },
  methods: {
    toNew () {
      window.open(this.info.url)
    }
  }
}
</script>
<style scoped>
.new{
  display: flex;
  width: 740px;
  height: 155px;
  background-color: #ffffff;
  margin: 10px auto;
}
.new img{
  height: 155px;
  width: 250px;
}
.new-title{
  font-size: 18px;
  font-weight: 600;
  margin-top: 15px;
}
.new-content{
  font-size: 14px;
  text-align: start;
  margin-left: 10px;
  margin-top: 20px;
}
</style>
